module.exports = __webpack_public_path__ + "static/media/8000.f5299fd0.jpg";